jQuery(document).ready(function(){
  jQuery('.recommended-products-carousel').slick({
	dots: false,
	slidesToShow: 3,
	slidesToScroll: 1,
	autoplay: false,
	arrows: true,
	responsive: [
	{
	  breakpoint: 1200,
	  settings: {
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true
	  }
	},
	{
	  breakpoint: 800,
	  settings: {
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true
	  }
	}
	]  });
});